import { render, staticRenderFns } from "./MagentoEditor.vue?vue&type=template&id=ab2900cc&scoped=true&"
import script from "./MagentoEditor.vue?vue&type=script&lang=js&"
export * from "./MagentoEditor.vue?vue&type=script&lang=js&"
import style0 from "./MagentoEditor.vue?vue&type=style&index=0&id=ab2900cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2900cc",
  null
  
)

export default component.exports